import { css } from 'lit';
export const elements = css `
    /* LAYOUTS */
    :host {
        font-family: 'Source Sans Pro', sans-serif;
        font-size: 16px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /* color: var(--text-primary); */
    }

    /* MOBILE STYLING */
    @media only screen and (max-width: 767px) {
        /* For mobile phones: */
        :host(.hideOnMobile),
        .hideOnMobile {
            display: none;
        }
    }

    /* DEFAULT */
    h1 {
        font-size: 28px;
        line-height: 45px;
        font-weight: 400;
    }

    h2 {
        font-size: 24px;
        line-height: 31px;
        font-weight: 400;
    }

    h3 {
        font-size: 20px;
        line-height: 26px;
        font-weight: 400;
    }

    h4 {
        font-size: 18px;
        line-height: 23px;
        font-weight: 400;
    }
`;
//# sourceMappingURL=sdb-elements.js.map